exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#pufferfish .reporting-v2.page .message-wrapper{border-top:1px solid #e7e5e6;text-align:center;color:#626262;font-size:1.2em;padding:30px 0}", ""]);
